import dayjs from '@/localPlugins/dayjs';

export const convertedCreatedToNow = (payload, setUpdated = true) => {
  const currentTime = dayjs().utc().toISOString();
  payload.created_at = currentTime;
  if (setUpdated) {
    payload.updated_at = currentTime;
  }
};
